import { useState } from "react";
import { format, parse } from "date-fns";
import { de } from "date-fns/locale";
import { CalendarDays } from "lucide-react";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

export default function DateField({ value, onChange, testId }) {
  const [open, setOpen] = useState(false);
  const date = value ? parse(value, "yyyy-MM-dd", new Date()) : undefined;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" className="flex h-9 w-full items-center justify-between rounded-md border border-input bg-transparent px-3 text-sm shadow-sm transition-colors hover:border-orange-300" data-testid={testId}>
          <span className="num">{date ? format(date, "dd.MM.yyyy") : "Datum wählen"}</span>
          <CalendarDays className="h-4 w-4 text-slate-500" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto border-slate-200 bg-white p-0" align="start" data-testid={`${testId}-calendar`}>
        <Calendar
          mode="single"
          locale={de}
          weekStartsOn={1}
          selected={date}
          defaultMonth={date}
          disabled={{ after: new Date() }}
          onSelect={(d) => { if (d) { onChange(format(d, "yyyy-MM-dd")); setOpen(false); } }}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}
